export const APPCONSTANTS = {
   API :{
    //BASEURL: "https://localhost:7173/maa/api/",
    BASEURL: "https://oilchakra.com/maa/api/",
    GetSimplifiedOrdersSummaryURL: "cryptoTax/GetSimplifiedOrdersSummary?orderType=spotorders",
    GetCoinLevels : "cryptoTax/GetCoinLevels",
    Register:"account/register",
    Login:"account/login",
    AddEnquiry:"Enquiry/addenquiry",
    GetCoinQualitiesByCycle:"coin/GetCoinQualitiesByCycle"
   }
}
   

export const TABLEHEADERS = {
   PROJECTION :["Levels","BTC","Down","Up","Exit"],
   COINHEALTH:["Name","Low","CP","High","C-Level","A-Level"]
}


export const MAX_LEVEL_COUNT = 30;
export const MAX_PERCENT = 1000;

export const COLUMN_CONFIG = [
  { key: "symbol", label: "Symbol" },
  { key: "currentPrice", label: "Current Price" },
  { key: "upCycleLow", label: "Up Cycle Low" },
  { key: "upCycleHigh", label: "Up Cycle High" },
  { key: "downCycleLow", label: "Down Cycle Low" },
  { key: "downCycleHigh", label: "Down Cycle High" },
  { key: "upCycleLowToUpCycleHigh_IncreasePercentage", label: "Up Low → High %" },
  { key: "upCycleLowToCurrentPrice_Percentage", label: "Up Low → CP %" },
  { key: "downCycleHighToDownCycleLow_Percentage", label: "Down High → Low %" },
  { key: "downCycleLowToCurrentPrice_IncreasePercentage", label: "Down Low → CP %" },
  { key: "upCycleHighToDownCycleLow_DecreasePercentage", label: "Up High → Down Low %" },
  { key: "upCycleLowToDownCycleLow_DecreasePercentage", label: "Up Low → Down Low %" },
  { key: "currentPriceToDownCycleLow_Percentage", label: "CP → Down Low %" },
  { key: "level", label: "Level" },
];

export const LEVELS = [
  10,20,30,40,50,60,70,80,90,100,
  200,300,400,500,600,700,800,900,1000
];
